import { NewsSection } from "./newsSection"



export const StatisticSection=()=>{
    
    const mastyle={
        background:'radial-gradient(closest-side, white 90%, transparent 80% 100%),conic-gradient(hotpink 75%, pink 0);'
    }
      
    const statiscticArr=[
        {
            color:{
                main:'#F89828',
                opacity:'#FFEFB2'
            },
            percent:90,
            value:'98%',
            title:'Totally satisfied clients'
        },
        {
            color:{
                main:'#F52F6E',
                opacity:'pink'
            },
            percent:98,
            value:'98%',
            title:'Totally satisfied clients'
        },
        {
            color:{
                main:'#5A87FC',
                opacity:'#B0F2FF'
            },
            percent:81,
            value:'98%',
            title:'Totally satisfied clients'
        },
        {
            color:{
                main:'#03CEA4',
                opacity:'#D5FFE6'
            },
            percent:100,
            value:'98%',
            title:'Totally satisfied clients'
        }
    ]


    return(
        <div className="statistic-section_bg">
            <div className="statistic-section __container">
                <div className="statistic-section_header">
                    <h1>Some facts and figures</h1>
                </div>
                <div className="statistic-section_progressbar-palceholder">
                    {statiscticArr.map((p,i)=>
                        <div className="statistic-section_progressbar-block" key={i} >
                            <div style={{background:`radial-gradient(closest-side, white 90%, transparent 70% 100%),conic-gradient(${p.color.main} ${p.percent}%, ${p.color.opacity} 0)`}}><p>{p.value}</p></div>
                            <span>{p.title}</span>
                        </div>
                    )}
                    
                </div>
                <NewsSection/>
                <div className="statistic-section_news_links">
                    <h1>Explore all our news posts</h1>
                    <a href="#"><p>View all news</p></a>
                </div>
            </div>
        </div>
    )
}